export default {
    name: "Percent difference",
    data:

    {
        "id": "d91c5966-2977-4c1e-b1a1-cef690116d60",
        "title": "Percent difference",
        "type": "Composite",
        "config": {
            "operator": "Multiply",
            "combine_on": "date",
            "left": {
                "id": "0185d71f-9f25-472f-bed6-b5811cf70303",
                "title": "Ratio difference",
                "type": "Composite",
                "config": {
                    "operator": "Divide",
                    "combine_on": "date",
                    "left": {
                        "id": "3ff2ad39-97cf-4fec-9390-0ee804367cb7",
                        "title": "Price delta from yesterday",
                        "type": "Formatter",
                        "config": {
                            "type_id": "delta",
                            "child": {
                                "id": "0801fe26-1539-4d43-967d-20cdf5076982",
                                "type": "Single",
                                "config": {
                                    "type_id": "vwap",
                                    "hub_id": 14,
                                    "product_id": "999",
                                    "hour": "12",
                                    "start_date": "2025-06-27",
                                    "end_date": "2025-08-26"
                                }
                            },
                            "start_date": "2025-06-27",
                            "end_date": "2025-08-26"
                        }
                    },
                    "right": {
                        "id": "eff9a745-580b-475e-ae53-c759d938f12b",
                        "title": "Price",
                        "type": "Single",
                        "config": {
                            "type_id": "vwap",
                            "hub_id": 14,
                            "product_id": "999",
                            "hour": "12",
                            "start_date": "2025-06-27",
                            "end_date": "2025-08-26"
                        }
                    }
                }
            },
            "right": {
                "id": "761b5629-d41b-4878-9692-2d7b4b09a759",
                "type": "Single",
                "config": {
                    "type_id": "constant_value",
                    "value": 100,
                    "start_date": "2025-06-27",
                    "end_date": "2025-08-26"
                }
            }
        }
    }
}